<template>
  <v-row>
    <v-col>
      <v-container id="perso-raw-data-content" class="perso-raw-data-content">
        <pre v-if="displayPayload.length > 2">{{ displayPayload }}</pre>
        <pre v-else>{{ $t('device.history.modal_details.no_data') }}</pre>
      </v-container>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { Personalisation } from 'ctp-personalisation-search';
import { computed, PropType } from 'vue';

const props = defineProps({
  perso: {
    type: Object as PropType<Personalisation>,
    default: () => ({})
  }
});

const displayPayload = computed(() => {
  if (props.perso.rawData) {
    const json = JSON.parse(props.perso.rawData);
    return JSON.stringify(json, undefined, 4);
  }
  return '';
});

</script>
<style lang="scss" scoped>
@import './styles/raw-data.scss';
</style>
